import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { CheckCircle } from '@phosphor-icons/react';

const RegistrationSuccessPage = ({ history }) => {
  const [regInfo, setRegInfo] = useState(null);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Load registration info from session storage
    const storedRegInfo = sessionStorage.getItem('registrationComplete');
    if (!storedRegInfo) {
      // If no registration data, redirect back to the beginning
      history.push('/register');
      return;
    }

    setRegInfo(JSON.parse(storedRegInfo));

    // Auto-redirect to login page after a countdown
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          navigateToLogin();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [history]);

  const navigateToLogin = () => {
    // Store subscription info in session storage to redirect after login
    const storedOrgInfo = JSON.parse(
      sessionStorage.getItem('registrationOrg') || '{}'
    );

    if (!regInfo?.email || !storedOrgInfo?.code) {
      console.error('Missing required registration information');
      history.push('/login');
      return;
    }

    // Save organization code to session storage for after login
    sessionStorage.setItem(
      'pendingSubscription',
      JSON.stringify({
        friendlyCode: storedOrgInfo.code,
        organizationName: regInfo.organizationName,
        subscriptionAmount: regInfo.subscriptionAmount,
      })
    );

    // Clear registration data that's no longer needed
    sessionStorage.removeItem('registrationOrg');
    sessionStorage.removeItem('registrationComplete');

    // Redirect to login page
    history.push({
      pathname: '/login',
      state: {
        email: regInfo.email,
        redirectAfterLogin: '/student/subscriptions/setup',
      },
    });
  };

  if (!regInfo) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-600"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen">
      <div
        className="w-full p-8 overflow-y-auto flex items-center justify-center flex-1 bg-cover bg-bottom"
        style={{ backgroundImage: 'url(/register.jpg)' }}
      >
        <div className="w-full md:max-w-md 2xl:max-w-xl">
          <div className="bg-white rounded-xl shadow-xl transform transition-all shadow-md hover:shadow-2xl focus:shadow-2xl">
            <div className="px-4 py-4 md:px-12 md:py-12 text-center">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 mb-6">
                <a
                  href="https://www.vrtus.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/logo_dark.jpg"
                    alt="Logo"
                    className="h-16 w-16 rounded-full object-cover cursor-pointer"
                  />
                </a>
              </div>

              <div className="flex justify-center text-green-500 mb-6">
                <CheckCircle size={80} weight="fill" />
              </div>

              <div className="text-3xl font-medium text-gray-900 mb-4">
                ¡Cuenta Creada!
              </div>

              <div className="text-gray-600 mb-2">
                Tu cuenta para {regInfo.organizationName} ha sido creada con
                éxito.
              </div>

              <div className="text-gray-600 mb-6">
                Inicia sesión para completar tu suscripción y acceder a tus
                cursos.
              </div>

              <button
                onClick={navigateToLogin}
                className="hover:bg-gray-600 font-medium rounded-lg text-lg px-6 py-2 bg-gray-500 text-white mb-4"
              >
                Continuar a Iniciar Sesión
              </button>

              <div className="text-sm text-gray-500">
                Redirigiendo automáticamente en {countdown} segundos...
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(RegistrationSuccessPage);
